<template>
    <div class="content-grid content-grid--subpage">
        <Breadcrumbs :title="t(`document.categories.${documentCategory}.name`)"/>
        <div class="content-grid__header">
          <BackLinkTitle :title="t(`document.categories.${documentCategory}.name`)"/>
          <div class="content-grid__filters">
            <SearchInput v-model="searchValue"/>
          </div>
        </div>
      <Card>
        <DocumentsTable
            :documents="documentsMatchingCategory"
            :is-loading="documentsAreLoading"
            :search-value="searchValue"
            @documents-updated="loadAllDocuments"/>
      </Card>
    </div>
</template>

<script lang="ts" setup>
import Card from '@/components/layout/Card.vue';
import BackLinkTitle from '@/components/layout/BackLinkTitle.vue';
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue';
import SearchInput from "@/components/layout/SearchInput.vue";
import {useI18n} from "vue3-i18n";
import {computed, onMounted, ref} from "vue";
import {DocumentCategoryHelper} from "@/types";
import DocumentsTable from '@/components/tables/DocumentsTable.vue';
import {Document} from "@/types/entities/document";
import {useDocumentService} from "@/inversify.config";

// eslint-disable-next-line
const props = defineProps<{
  documentCategorySlug: string
}>()

const {t} = useI18n();

const documentService = useDocumentService();

const searchValue = ref("");
const documentsAreLoading = ref(false)
const documentsMatchingCategory = ref<Document[]>([]);

const documentCategory = computed(() => DocumentCategoryHelper.getCategoryNameFromSlug(props.documentCategorySlug))
const documentCategoryKey = computed(() => DocumentCategoryHelper.getCategoryValueOfKey(documentCategory.value))

onMounted(async () => {
  await loadAllDocuments()
})

async function loadAllDocuments() {
  documentsAreLoading.value = true;
  documentsMatchingCategory.value = [];

  let documents = await documentService.getAllDocuments();
  if (documents && documents.length > 0) {
    documentsMatchingCategory.value = documents.filter((x: Document) => x.category == documentCategoryKey.value)
  }
  documentsAreLoading.value = false;
}
</script>
